import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PETITION_URL } from "@/lib/content";
import { track } from "@/lib/analytics";

const sizes = {
  xl: "min-h-[60px] px-10 text-xl",
  lg: "min-h-[52px] px-8 text-lg",
  md: "min-h-[48px] px-6 text-base",
  sm: "min-h-[40px] px-5 text-sm",
};

const tones = {
  solid: "bg-gooi-green text-gooi-offwhite hover:bg-gooi-forest",
  light: "bg-gooi-offwhite text-gooi-green hover:bg-white",
  red: "bg-gooi-red text-white hover:bg-[#b92c2e]",
  outline: "border border-gooi-green/30 text-gooi-green hover:bg-gooi-green hover:text-gooi-offwhite",
};

export const PetitionCTA = ({
  location,
  children = "Teken de petitie",
  size = "lg",
  tone = "solid",
  className = "",
}) => (
  <motion.a
    href={PETITION_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`petition-cta-${location}`}
    onClick={() => track("petition_click", { cta_location: location })}
    whileTap={{ scale: 0.97 }}
    whileHover={{ scale: 1.02 }}
    className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-display font-semibold tracking-tight transition-colors duration-300 ${sizes[size]} ${tones[tone]} ${className}`}
  >
    {children}
    <ArrowUpRight className="h-5 w-5 shrink-0" strokeWidth={1.5} aria-hidden="true" />
  </motion.a>
);
